export default __webpack_public_path__ + "static/media/likeNotDone.92706a5b.svg";